import type { SharedProps } from '@bonniernews/dn-design-system-web/assets/types/shared-props.ts'

import { formatClassString } from '@bonniernews/dn-design-system-web/helpers/formatClassString.ts'

export interface BadgeProps extends SharedProps {
  figure?: number
  forcePx?: boolean
}

/**
 * - GitHub: [BonnierNews/dn-design-system/web/src/components/badge](https://github.com/BonnierNews/dn-design-system/tree/main/web/src/components/badge)
 * - Storybook: [Badge](https://designsystem.dn.se/?path=/docs/basic-badge--docs)
 *
 * The component will not include styling by itself. Make sure to include the right styles for the component. See example below:
 * `@use '@bonniernews/dn-design-system-web/components/badge/badge.scss'`
 */
export const Badge = ({ figure, forcePx, classNames, attributes }: BadgeProps) => {
  const componentClassName = 'ds-badge'
  let variant = 'empty'

  if (figure) {
    variant = figure < 10 ? 'single' : 'double'
  }

  const classes = formatClassString([
    componentClassName,
    `${componentClassName}--${variant}`,
    forcePx && 'ds-force-px',
    classNames,
  ])

  return (
    <div className={classes} {...attributes}>
      <span className='ds-badge__inner'>{figure && (variant === 'double' ? '9+' : figure)}</span>
    </div>
  )
}
